import React, { useEffect } from 'react';
import styles from './TelegramIntegrationForm.module.scss';
import Input from '../../ui/Input/Input';
import TextArea from '../../ui/TextArea/TextArea';
import Select from '../../ui/Select/Select';
import { useDispatch, useSelector } from 'react-redux';
import {
    setNewBot,
    setUpdateBot,
    setUpdateDataBot,
} from '../../store/slices/integrationSlice';
import ScreenHeader from '../ScreenHeader/ScreenHeader';
import TelegramIcon from '../../assets/icons/TelegramIcon';
import SaveIcon from '../../assets/icons/SaveIcon';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { stepsDataTokenTgBot } from '../../assets/consts/tooltipDataTgBot';
import { validateFieldsTgBot } from '../../utils/methods/validationField';
import {
    postNewBotData,
    updateTgBot,
} from '../../utils/api/actions/integrations/tgBot';

const TelegramIntegrationForm = ({ data }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const newBot = useSelector((state) => state?.integration?.newBot);
    const activeBot = useSelector((state) => state?.integration?.activeBot);
    const updateBot = useSelector((state) => state?.integration?.updateBot);
    const updateDataBot = useSelector(
        (state) => state?.integration?.updateDataBot
    );
    const assistants = useSelector((state) => state?.assistant?.dataAssistants);
    const id =
        useSelector((state) => state.user?.data?.id) ||
        localStorage.getItem('@storage_User_Id');

    useEffect(() => {
        if (updateBot && data?.activeBot) {
            dispatch(setUpdateDataBot(data.activeBot));
        }
    }, [updateBot, data, dispatch]);

    const handlerInput = (e) => {
        const { name, value } = e.target;
        if (newBot) {
            dispatch(setNewBot({ ...newBot, [name]: value }));
        } else if (updateDataBot) {
            dispatch(setUpdateDataBot({ ...updateDataBot, [name]: value }));
        }
    };

    const selectObserver = (val) => {
        if (newBot) {
            dispatch(setNewBot({ ...newBot, assistantId: val }));
        } else if (updateDataBot) {
            dispatch(setUpdateDataBot({ ...updateDataBot, assistantId: val }));
        }
    };

    const errorFields = (messages) => {
        toast.dismiss('customId');
        messages.forEach((message) =>
            toast.error(message, { toastId: 'customId' })
        );
    };

    const isEmptyObject = (obj) => obj && Object.keys(obj).length > 0;

    const handleSave = () => {
        if (isEmptyObject(newBot)) {
            if (validateFieldsTgBot(newBot, errorFields)) {
                dispatch(postNewBotData(newBot, id));
                dispatch(setNewBot(null));
                navigate('/integration');
            }
        }
        if (isEmptyObject(updateDataBot)) {
            if (validateFieldsTgBot(updateDataBot, errorFields)) {
                let data = {
                    id: updateDataBot.id,
                    userName: updateDataBot.userName,
                    name: updateDataBot.name,
                    about: updateDataBot.about,
                    token: updateDataBot.token,
                    helloMessage: updateDataBot.helloMessage,
                    userId: updateDataBot.userId,
                    assistantId: updateDataBot.assistantId,
                    active: true, // поменять потом как сделаешь состояние отключегия
                };
                dispatch(updateTgBot(data, navigate));
            }
        }
    };

    const handleCancel = () => {
        if (updateBot && updateDataBot?.id) {
            navigate(`/integration/telegram-bot/active/${updateDataBot.id}`);
            dispatch(setUpdateDataBot(null));
            dispatch(setUpdateBot(false));
        } else {
            dispatch(setNewBot(null));
            navigate('/integration');
        }
    };

    const hint = {
        id: 'tokenBot',
        stepsData: stepsDataTokenTgBot,
    };

    const actions = [
        {
            title: 'Сохранить',
            icon: <SaveIcon />,
            className: styles.addButton,
            titleClassName: styles.titleAddButton,
            onClick: handleSave,
        },
        {
            title: 'Отмена',
            className: styles.cancelButton,
            titleClassName: styles.titleCancelButton,
            onClick: handleCancel,
        },
    ];

    const assistantName =
        assistants?.find((assistant) => assistant.id === newBot?.assistantId)
            ?.name || 'Ассистент не найден';

    return (
        <div className={styles.body}>
            <ScreenHeader
                title={
                    <>
                        Новая интеграция <TelegramIcon />
                    </>
                }
                actions={actions}
            />
            <div className={styles.inputContainer}>
                <Input
                    className={styles.child}
                    label="Имя пользователя"
                    name="userName"
                    labelStyle={styles.labelInput}
                    backgroundStyle={styles.labelBackground}
                    inputStyle={styles.input}
                    value={newBot?.userName || updateDataBot?.userName || ''}
                    onChange={handlerInput}
                />
                <Input
                    className={styles.child}
                    label="Название"
                    name="name"
                    labelStyle={styles.labelInput}
                    backgroundStyle={styles.labelBackground}
                    inputStyle={styles.input}
                    value={newBot?.name || updateDataBot?.name || ''}
                    onChange={handlerInput}
                />
            </div>
            <div className={styles.inputContainer}>
                <Input
                    hint={hint}
                    className={styles.child}
                    label="Токен"
                    name="token"
                    labelStyle={styles.labelInput}
                    backgroundStyle={styles.labelBackground}
                    inputStyle={styles.input}
                    value={newBot?.token || updateDataBot?.token || ''}
                    onChange={handlerInput}
                    classNameTooltip={styles.tooltip}
                />
            </div>
            <div className={styles.textareaContainer}>
                <TextArea
                    label="Описание"
                    rows="3"
                    labelStyle={styles.labelTextArea}
                    textAreaStyle={styles.textarea}
                    value={
                        newBot?.description || updateDataBot?.description || ''
                    }
                    onChange={handlerInput}
                    name="description"
                />
            </div>
            <div className={styles.textareaContainer}>
                <TextArea
                    label="Короткое описание"
                    rows="3"
                    labelStyle={styles.labelTextArea}
                    textAreaStyle={styles.textarea}
                    value={newBot?.about || updateDataBot?.about || ''}
                    onChange={handlerInput}
                    name="about"
                />
            </div>
            <div className={styles.textareaContainer}>
                <TextArea
                    placeholder="Привет, [username]!"
                    label="Приветственное сообщение"
                    rows="3"
                    labelStyle={styles.labelTextArea}
                    textAreaStyle={styles.textarea}
                    value={
                        newBot?.helloMessage ||
                        updateDataBot?.helloMessage ||
                        ''
                    }
                    onChange={handlerInput}
                    name="helloMessage"
                />
                <label className={styles.subtitle}>
                    [username] - подменяется на имя пользователя
                </label>
            </div>
            <Select
                assistants={assistants}
                title="Ассистент"
                selectObserver={selectObserver}
                activeBot={activeBot}
                labelStyle={styles.labelSelect}
                nameSelectedOption={assistantName}
            />
        </div>
    );
};

export default TelegramIntegrationForm;
